import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ApproveBatchParticipationPaymentBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const approveBatchPayment = createAsyncThunk<void, ApproveBatchParticipationPaymentBody, { extra: Partial<Dependencies> }>(
  "batchPayments/approveBatchPayment",
  async (data: ApproveBatchParticipationPaymentBody, { extra: { adminRepository } }) => {
    return adminRepository!.approvePayment(data);
  },
);

export const resetApproveBatchPayment = createAction("batchPayments/resetApproveBatchPayment");
